// The enum values here should be matched to the exact string
// returned by the server otherwise parsing the response won't
// be able to convert it to the correct enum.
export var SharingLinkProviderType;
(function (SharingLinkProviderType) {
    SharingLinkProviderType["OneDrivePro"] = "OneDrivePro";
})(SharingLinkProviderType || (SharingLinkProviderType = {}));
export var SharingLinkType;
(function (SharingLinkType) {
    SharingLinkType["None"] = "None";
    SharingLinkType["View"] = "View";
    SharingLinkType["Edit"] = "Edit";
    SharingLinkType["AnonymousView"] = "AnonymousView";
    SharingLinkType["AnonymousEdit"] = "AnonymousEdit";
    SharingLinkType["OrganizationView"] = "OrganizationView";
    SharingLinkType["OrganizationEdit"] = "OrganizationEdit";
})(SharingLinkType || (SharingLinkType = {}));
//# sourceMappingURL=SharingLinkInfoResponse.js.map